export enum Schedules {
  oneTime = 0,
  monthly = 1,
  bimonthly = 2,
  quarterly = 3,
  yearly = 12,
}
